import { updateRFPContent } from "../utilities/updateRFPContent";

export const RFPSection = ({section, content, title, setDocumentData, enterPressed, documentData}) =>{
   
    
    
    // key functions
        const handleEnterPressLineBreak = (e) => {
            if (e.key === "Enter") {
                e.preventDefault(); // ✅ Stop the browser from creating a new <div>
                document.execCommand("insertLineBreak"); // ✅ Insert a line break instead
            }
        };
        const handleEnterInList = (e, section, index) => {
            if (e.key === "Enter") {
                e.preventDefault(); // ✅ Prevents default behavior            
                enterPressed = true;
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                let currentElement = range.startContainer;
        
                // 🔥 Ensure we're inside a text node
                if (currentElement.nodeType === Node.TEXT_NODE) {
                    currentElement = currentElement.parentElement;
                }
        
                // 🔥 Ensure we're inside a <p> inside an <li>
                const paragraph = currentElement.closest("p");
                if (!paragraph) return;
        
                // **Split text at cursor position**
                const cursorPosition = range.startOffset;
    
        
                // Perform logic before updating state
                    const updatedDocumentData = { ...documentData }; // Shallow copy of state
                    const updatedSection = [...updatedDocumentData[section]]; // Copy section array
    
                    const originalText = paragraph.innerText;
                    const textBeforeCursor = originalText.slice(0, cursorPosition);
                    const textAfterCursor = originalText.slice(cursorPosition);
    
                    // Modify section data
                    updatedSection[index] = textBeforeCursor;
                    updatedSection.splice(index + 1, 0, textAfterCursor || "");
    
                    // Assign back to document data
                    updatedDocumentData[section] = updatedSection;
    
                
                    setDocumentData(updatedDocumentData);
                  
                // **🔥 Move cursor to the new contentEditable element after React updates the DOM**
                setTimeout(() => {
                    const newElement = document.getElementById(`${section}-${index + 1}`);
                    if (newElement) {
                        const newRange = document.createRange();
                        newRange.setStart(newElement, 0);
                        newRange.collapse(true);
        
                        const selection = window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(newRange);
                        }
                    enterPressed = false; // Reset the flag
                }, 100); // Small timeout to allow DOM update
            }
        };
        const handleDeleteInList = (e, section, index) => {
            if (e.key === "Backspace" || e.key === "Delete") {
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                let currentElement = range.startContainer;
        
                // ✅ Ensure we're inside a text node
                if (currentElement.nodeType === Node.TEXT_NODE) {
                    currentElement = currentElement.parentElement;
                }
        
                // ✅ Ensure we're inside a <p> inside an <li>
                const paragraph = currentElement.closest("p");
                if (!paragraph) return;
        
                // **Get cursor position**
                const cursorPosition = range.startOffset;
                const textContent = paragraph.innerText;
                const textBeforeCursor = textContent.slice(0, cursorPosition);
                const textAfterCursor = textContent.slice(cursorPosition);
        
                // **Only proceed if the cursor is at the start of the text (Backspace case)**
                if (e.key === "Backspace" && cursorPosition === 0 && index > 0) {
                    e.preventDefault(); // ✅ Prevents default backspace behavior
        
                    const updatedDocumentData = { ...documentData }; // Shallow copy
                    const updatedSection = [...updatedDocumentData[section]]; // Copy section array
        
                    // **Merge with the previous item**
                    const previousItem = updatedSection[index - 1];
                    updatedSection[index - 1] = previousItem + textAfterCursor; // Append content to the previous item
                    updatedSection.splice(index, 1); // Remove the current item
        
                    // Assign back to document data
                    updatedDocumentData[section] = updatedSection;
        
                    // **🔥 Update state**
                    setDocumentData(updatedDocumentData);
        
                    // **Move cursor to the end of the previous item**
                    setTimeout(() => {
                        const previousElement = document.getElementById(`${section}-${index - 1}`);
                        if (previousElement) {
                            const selection = window.getSelection();
                            const newRange = document.createRange();
                            let textNode = previousElement.firstChild;
                            // Get the length of the previous list item's text content
                            const previousText = documentData[section][index - 1] || "";
                            const cursorPosition = previousText.length;
                            while (textNode && textNode.nodeType !== Node.TEXT_NODE) {
                                textNode = textNode.firstChild;
                            }
                            // Place the cursor at the exact position after the last character
                            if (previousElement && previousElement.firstChild && previousElement.firstChild.nodeType === Node.TEXT_NODE) {
                            newRange.setStart(previousElement.firstChild, cursorPosition);
                            newRange.collapse(true);
                            }
                            else{
                                const targetNode = previousElement.firstChild || previousElement;
                                range.setStart(targetNode, 0);
                                range.collapse(true);
                            }
                    
                            selection.removeAllRanges();
                            selection.addRange(newRange);
                    
                        }
                    }, 50);
                    
                }
        
                // **Only proceed if the cursor is at the end of the text (Delete case)**
                if (e.key === "Delete" && cursorPosition === textContent.length && index < documentData[section].length - 1) {
                    e.preventDefault(); // ✅ Prevents default delete behavior
        
                    const updatedDocumentData = { ...documentData };
                    const updatedSection = [...updatedDocumentData[section]];
        
                    // **Merge with the next item**
                    const nextItem = updatedSection[index + 1];
                    updatedSection[index] = textBeforeCursor + nextItem; // Append next item's content
                    updatedSection.splice(index + 1, 1); // Remove the next item
        
                    updatedDocumentData[section] = updatedSection;
        
                   
                    // **🔥 Update state**
                    setDocumentData(updatedDocumentData);
        
                    // **Keep cursor at the end of the current item**
                    setTimeout(() => {
                        const currentElement = document.getElementById(`${section}-${index}`);
                        if (currentElement) {
                            const newRange = document.createRange();
                            newRange.selectNodeContents(currentElement);
                            newRange.collapse(false); // Move to end
        
                            const selection = window.getSelection();
                            selection.removeAllRanges();
                            selection.addRange(newRange);
                            }
                    }, 100);
                }
            }
        };
        const handleArrowNavigation = (e, section, index) => {
            if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
        
            e.preventDefault(); // Prevents default scrolling behavior
        
            const selection = window.getSelection();
            const range = selection.getRangeAt(0);
            let currentElement = range.startContainer;
        
            // 🔥 Ensure we're inside a <p> inside an <li>
            if (currentElement.nodeType === Node.TEXT_NODE) {
                currentElement = currentElement.parentElement;
            }
            const paragraph = currentElement.closest("p");
            if (!paragraph) return;
        
            // **Get the cursor position in the current line**
            const cursorPosition = range.startOffset;
            
            // **Determine target index based on key pressed**
            const targetIndex = e.key === "ArrowUp" ? index - 1 : index + 1;
        
            // **Get target element**
            const targetElement = document.getElementById(`${section}-${targetIndex}`);
        
            // **Ensure target exists before moving**
            if (!targetElement) {
                return;
            }
        
            
            // **Find the deepest text node inside the target paragraph**
            let textNode = targetElement.firstChild;
            while (textNode && textNode.nodeType !== Node.TEXT_NODE) {
                textNode = textNode.firstChild;
            }
        
            if (textNode) {
                const newRange = document.createRange();
                const selection = window.getSelection();
        
                // **Ensure cursor doesn't go beyond text length**
                const newCursorPos = Math.min(cursorPosition, textNode.length);
        
                newRange.setStart(textNode, newCursorPos);
                newRange.collapse(true);
        
                selection.removeAllRanges();
                selection.addRange(newRange);
            } else {
                console.warn("⚠ No valid text node found in target element.");
            }
        };    
    
    
    return (
            <div className="rfp-section">
                <p className="rfp-section-title">{title}</p>
                {Array.isArray(content) ? (
                    <ul>
                        {content.map((item, index) => (
                            <li key={index}>
                                <p id={`${section}-${index}`} className="rfp-section-content" onKeyDown={(e) => {handleEnterInList(e, section, index); handleDeleteInList(e, section, index); handleArrowNavigation(e,section, index)}} contentEditable='true' suppressContentEditableWarning= {true} onBlur = {(e)=>updateRFPContent(section, e.target.textContent, index, setDocumentData, enterPressed)}>{item}</p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="rfp-section-content" onKeyDown={handleEnterPressLineBreak} contentEditable='true' suppressContentEditableWarning= {true} onBlur = {(e)=>updateRFPContent(section, e.target.textContent, undefined, setDocumentData, enterPressed)}>{content}</p>
                )}
            </div>
        )
    }